<template>
  <div class="c-general">
    <h1 class="c-users-information__title">{{ $t('usersInformation.general.title') }}</h1>
    <p class="c-users-information__text">{{ $t('usersInformation.general.text') }}</p>
    <!-- row-1 -->
    <div class="form-row">
      <label class="form-row__label required">{{ $t('usersInformation.general.username') }}</label>
      <p4a-input
        :disabled="true"
        :placeholder="username"
        :type="'text'"
        :size="'small'"
      />
    </div>
    <!-- row-2 -->
    <div class="form-row">
      <label class="form-row__label required">{{ $t('usersInformation.general.name') }}</label>
      <p4a-input
        :disabled="NameIsReadOnly"
        :value="name"
        @input="$emit('update:name', $event)"
        :warning="{ visible: name.length === 0, showIcon: true, message: $t('general.errorEmptyField'), warningMessageOnBottom: false }"
        :type="'text'"
        :size="'small'"
        :leftIcon="''"
      />
    </div>
    <!-- row-3 -->
    <div class="form-row">
      <label class="form-row__label required">{{ $t('usersInformation.general.email') }}</label>
      <p4a-input
        :disabled="EmailIsReadOnly"
        :value="email"
        @input="showPasswordInput($event)"
        :warning="email.length === 0 ? { visible: email.length === 0, showIcon: true, message: $t('general.errorEmptyField'), warningMessageOnBottom: false } : { visible: emailIsInvalid, showIcon: true, message: $t('general.errorInvalidEmail'), warningMessageOnBottom: false }"
        :type="'text'"
        :size="'small'"
        :leftIcon="''"
      />
    </div>
    <!-- row-3.5 hidden -->
    <div class="form-row" v-if="!PasswordInputHidden">
      <label class="form-row__label">{{ $t('usersInformation.general.confirmPassword') }}</label>
      <p4a-input
      v-model="password"
        :type="'password'"
        :value="password"
        @input="emitToParent"
        :size="'small'"
        :leftIcon="''"
        :warning="password.length === 0 ? { visible: password.length === 0, showIcon: true, message: $t('general.errorEmptyField'), warningMessageOnBottom: false } : { visible: showPasswordMatchWarning, showIcon: true, message: $t('login.resetDiffer'), warningMessageOnBottom: false }"
      />
    </div>
    <!-- row-4 -->
    <div class="form-row">
      <label class="form-row__label">{{ $t('usersInformation.general.toInform') }}</label>
      <select-drop-down
        class="input-medium"
        :place-holder="$t('usersInformation.general.dropdownOptions')[toInform]"
        :items="$t('usersInformation.general.dropdownOptions')"
        :disabled="false"
        @onchange="updateToInform"
      />
    </div>
    <!-- row-5 -->
    <div class="form-row">
      <label class="form-row__label">{{ $t('usersInformation.general.description') }}</label>
      <p4a-textarea
        :value="description"
        @input="$emit('update:description', $event)"
        class="form-row__textarea"
        :height="220"
        :resizable="true"
        :disabled="false">
      </p4a-textarea>
    </div>
    <!-- row-6 -->
    <div class="form-row">
      <label class="form-row__label">{{ $t('usersInformation.general.password') }}</label>
      <p4a-button
        @click="resetPassword"
        class="resetEmailButton"
        :showIcon="false"
        :onlyIconVisible="false"
        :product="'ts'"
        :size="'small'"
        :fullWidth="true"
        :disable="false"
        :text="$t('usersInformation.general.resetEmail')">
      </p4a-button>
    </div>
  </div>
</template>

<script>
import selectDropDown from '../../../dropdown/selectDropDown'

import * as usersInformationApi from 'api/usersInformationApi'

export default {
  components: { selectDropDown },
  props: {
    username: {
      type: String
    },
    name: {
      type: String
    },
    email: {
      type: String
    },
    toInform: {
      type: Number
    },
    description: {
      type: String
    },
    emailIsInvalid: {
      type: Boolean,
      default: false
    },
    EmailIsReadOnly: {
      type: Boolean,
      default: false
    },
    NameIsReadOnly: {
      type: Boolean,
      default: false
    },
    UsernameIsReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      PasswordInputHidden: true,
      password: ''
    }
  },
  computed: {
    showPasswordMatchWarning () {
      return this.$store.getters.getShowPasswordMatchWarning
    }
  },
  methods: {
    updateToInform (newValue) {
      this.$emit('update:toInform', this.$i18n.t('usersInformation.general.dropdownOptions').indexOf(newValue))
    },
    resetPassword () {
      usersInformationApi.resetPassword({Username: this.username})
    },
    showPasswordInput ($event) {
      this.$emit('update:email', $event)
      this.PasswordInputHidden = false
      this.$store.commit('setRevalidatePassword', !this.PasswordInputHidden)
    },
    emitToParent () {
      this.$emit('reEnterPassword', this.password)
      this.$store.commit('setShowPasswordMatchWarning', false)
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/userControls/management/usersInformation/General.vue